export enum LanguageType {
    EN = 'en',
    TR = 'tr',
}
